module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-07.e0d3f199.png";